import GpsExtractor from './gps_extractor'
import { isHeicFile } from './file_utils'

class SiteImageForm
  constructor: (selector) ->
    @form = $ selector
    @imageInput = @form.find 'input#site_image_image'
    @addressInput = @form.find 'input#site_image_address'
    @imageContainer = @form.find '.image-container'

    @initializeGeocomplete()

    hasImage = @imageContainer.children().length > 0
    @imageContainer.toggle hasImage

    @bindEvents()

  initializeGeocomplete: () ->
    google.maps.importLibrary('places').then () =>
      @addressInput.geocomplete country: 'DK'
      @geocomplete = @addressInput.data 'plugin_geocomplete'
      @geocoder = @geocomplete.geocoder
      @gpsExtractor = new GpsExtractor(@addressInput, @geocoder)
    .catch (error) ->
      console.error 'Error loading Google Maps:', error

  bindEvents: () ->
    @imageInput.on 'change', this.handleImageInputChange

  readAndApplyImageFile: (file) ->
    return unless 'FileReader' of window
    @imageContainer.empty()

    if isHeicFile(file)
      @showHeicPlaceholder(file)
    else
      reader = new FileReader()
      img = new Image()

      reader.addEventListener 'load', () ->
        img.src = reader.result

      img.addEventListener 'load', () =>
        @imageContainer.append(img).show()

      reader.readAsDataURL(file)

  showHeicPlaceholder: (file) ->
    placeholder = $("""
      <div class="heic-preview">
        <i class="fa fa-image fa-3x"></i>
        <p><strong>#{file.name}</strong></p>
        <small>HEIC forhåndsvisning ikke tilgængelig.<br>Billedet vises efter upload.</small>
      </div>
    """)
    @imageContainer.append(placeholder).show()

  handleImageInputChange: ({ target }) =>
    return unless target.files && target.files.length > 0

    $(target.files).each (key, file) =>
      @readAndApplyImageFile file
      @gpsExtractor?.extractAndApply file

initializeSiteImageForm = () ->
  new SiteImageForm('form')

window.initializeSiteImageForm = initializeSiteImageForm
